import ImageClass from "../../src/shell/Image";
import { jump } from "../../src/shell/jump";
import Question from "../../src/shell/Questions";
import { images } from "./images";

import { mc } from "../characters/MC";
import { emily } from "../characters/Emily";
import { doTransition, doWaitImageByTime, isAnnGF } from "../helpers/helpers";
import { V9EmilyMorningRoomDay3After } from "./V9";

const v9 = images.v9;
export const V9EmilyMorningRoomDay3 = async (): Promise<any> => {
    doTransition(images.v9.V9EmilyMorningRoomDay3_0);
    if (Question.globalAnswers.v9emilyMorningDay2TouchedHer) {
        mc.think(`Morning...`);
        doWaitImageByTime(images.v9.V9EmilyMorningRoomDay3_1);
        mc.think(`Emily... And she is topless.`);
        mc.think(`She had plenty of time to get dressed but she chose not to.`);
        mc.think(`Wow. I guess our previous conversation had an impact on her...`);
        mc.think(`And I also wonder if she felt me cumming on her leg...`);

    } else {
        // MC will come to her room from his room and they'll talk. She will have top on.

    }
    mc.talk(`Good morning.`);
    ImageClass.setImage(images.v9.V9EmilyMorningRoomDay3_2);
    emily.talk(`Finally!`);
    doWaitImageByTime(v9.V9EmilyMorningRoomDay3_3);
    await emily.setQuestion(new Question({ text: `I was so tempted to wake you up.`, options: { think: false }, key: `v9EmilyMorningDay3CheckedHerOut` })
        .option({ title: `Check her out`, key: true })
        .option({ title: `Don't check her out`, key: false }));


    if (Question.globalAnswers.v9EmilyMorningDay3CheckedHerOut) {
        // TODO: write something
        await mc.set((properties) => {
            properties.emilyRelationship += 2;
        });
        doWaitImageByTime(images.v9.V9EmilyMorningRoomDay3_4, { wait: true });

    }

    ImageClass.setImage(v9.V9EmilyMorningRoomDay3_3);
    emily.talk(`Tell me! How did the night go?`);
    ImageClass.setImage(v9.V9EmilyMorningRoomDay3_6);
    if (Question.globalAnswers.v9AlexDateAfterJoinedHerWater) {
        mc.talk(`I must admit. It was more romantic than I'd thought it would be.`);
    } else {
        mc.talk(`More or less your typical date.`);
    }
    // FIXME: sheets
    ImageClass.setImage(v9.V9EmilyMorningRoomDay3_7);
    emily.talk(`No no, that won't do! I want to hear all the details.`);
    ImageClass.setImage(v9.V9EmilyMorningRoomDay3_6);
    mc.talk(`Can I brush my teeth first at least?`);
    ImageClass.setImage(v9.V9EmilyMorningRoomDay3_7);
    emily.talk(`Details first.`);
    mc.talk(`Fine...`);


    if (Question.globalAnswers.v9AlexDateAfterJoinedHerWater) {
        ImageClass.setImage(v9.V9EmilyMorningRoomDay3_3);
        mc.talk(`Well... At first it went like your typical date...`);
        mc.talk(`I picked her from her home. We walked to the restaurant, had a really nice chat there.`);
        mc.talk(`But it really took off once we got out of there.`);
        ImageClass.setImage(v9.V9EmilyMorningRoomDay3_8);
        mc.talk(`We walked down the pier and she jumped into the water topless.`);
        ImageClass.setImage(v9.V9EmilyMorningRoomDay3_9);
        emily.talk(`Please tell me you joined her!`);
        ImageClass.setImage(v9.V9EmilyMorningRoomDay3_6);
        mc.talk(`Of course I did.`);
        ImageClass.setImage(v9.V9EmilyMorningRoomDay3_9);
        emily.talk(`Yes! Then?`);
        mc.talk(`We kissed... And kissed...`);
        ImageClass.setImage(v9.V9EmilyMorningRoomDay3_5);
        emily.talk(`Awwww! How cute!`);
        mc.talk(`Yeah, I guess.`);
        ImageClass.setImage(v9.V9EmilyMorningRoomDay3_10);
        emily.talk(`And...? Did you seal the deal?`);
        ImageClass.setImage(v9.V9EmilyMorningRoomDay3_6);
        mc.talk(`I think I could have under other circumstances.`);
        mc.talk(`Even though Ann told her not to hold herself back she did... That's why she didn't invite me inside her home.`);
        ImageClass.setImage(v9.V9EmilyMorningRoomDay3_5);
        emily.talk(`I guess that makes sense.`);
        ImageClass.setImage(v9.V9EmilyMorningRoomDay3_10);
        emily.talk(`Tough for you though.`);
        mc.talk(`Very.`);

    } else {
        ImageClass.setImage(v9.V9EmilyMorningRoomDay3_6);
        mc.talk(`I'm serious.`);
        mc.talk(`I picked her from her home. We walked to the restaurant, had a nice chat and walked back home...`);
    }
    ImageClass.setImage(images.v9.V9EmilyMorningRoomDay3_3);
    emily.talk(`So now what? You going to see her again?`);
    ImageClass.setImage(images.v9.V9EmilyMorningRoomDay3_8);
    mc.talk(`Not sure... Ann wanted us to go on a single date...`);
    mc.talk(`It's stupid, but I think it's up to Ann to decide.`);
    if (isAnnGF()) {
        ImageClass.setImage(images.v9.V9EmilyMorningRoomDay3_5);
        emily.talk(`Well... Letting her boyfriend make out with her best friend is already something not many girls would allow.`);
        // happened
        if (Question.globalAnswers.V8AnnDateMCOkWithChris !== undefined) {
            if (Question.globalAnswers.V8AnnDateMCOkWithChris) {
                ImageClass.setImage(images.v9.V9EmilyMorningRoomDay3_8);
                mc.talk(`Well... If I'm being totally honest...`);
                mc.talk(`I allowed something similar for her.`);
            } else {
                mc.talk(`Well... If I'm being totally honest...`);
                mc.talk(`I'm not allowing the same for her.`); 
            }
            ImageClass.setImage(images.v9.V9EmilyMorningRoomDay3_7);
            emily.talk(`Whaaat? Explain fast!`);
            ImageClass.setImage(images.v9.V9EmilyMorningRoomDay3_8);
            mc.talk(`During our first date, this bartender named Chris asked me if he can hit on her...`);
            mc.talk(`I said yes and they are now dating as well.`);
            ImageClass.setImage(images.v9.V9EmilyMorningRoomDay3_11);
            emily.talk(`Wow... Dating two guys!`);
            emily.talk(`And here I was giving her points for allowing you to date Alex!`);
            emily.talk(`She was just returning the favor!`);
            ImageClass.setImage(images.v9.V9EmilyMorningRoomDay3_8);
            mc.talk(`I'm not sure if that's the case, but it is what it is.`);
            if (Question.globalAnswers.V8AnnDateMCOkWithChris) {
                ImageClass.setImage(images.v9.V9EmilyMorningRoomDay3_11);
                emily.talk(`And are you fine with them dating?`);
                ImageClass.setImage(images.v9.V9EmilyMorningRoomDay3_8);
                mc.talk(`Yup. We talked about that and I told her I have no problem with that.`);
                // TODO: add more meat, and maybe have some phycology sentences that would lead to the MC thinking something and have a conversation with Ann about that.

            } else {
                ImageClass.setImage(images.v9.V9EmilyMorningRoomDay3_11);
                emily.talk(`And how do you know they stopped seeing each other?`);
                if (Question.globalAnswers.v9AnnDormNightChrisMasturbated !== undefined) {
                    ImageClass.setImage(images.v9.V9EmilyMorningRoomDay3_8);
                    mc.talk(`That's another issue...`);
                    mc.talk(`I caught them hooking up behind my back.`);
                    ImageClass.setImage(images.v9.V9EmilyMorningRoomDay3_11);
                    emily.talk(`That slut!`);
                    ImageClass.setImage(images.v9.V9EmilyMorningRoomDay3_7);
                    emily.talk(`Oh my god, I can't believe how much you haven't told me!`);
                    emily.talk(`Too bad you didn't fuck Alex just to get back at her!`);
                    if (Question.globalAnswers.v9AnnDormNightChrisMasturbated) {
                        ImageClass.setImage(images.v9.V9EmilyMorningRoomDay3_8);
                        mc.talk(`Relax... I don't have a problem with it.`);
                        ImageClass.setImage(images.v9.V9EmilyMorningRoomDay3_11);
                        emily.talk(`Are you serious with me right now?`);
                        ImageClass.setImage(images.v9.V9EmilyMorningRoomDay3_8);
                        mc.talk(`I am.`);
                    } else {
                        ImageClass.setImage(images.v9.V9EmilyMorningRoomDay3_8);
                        mc.talk(`I might do it in the future, who knows?`);
                        ImageClass.setImage(images.v9.V9EmilyMorningRoomDay3_11);
                        emily.talk(`Well! You should!`);
                    }



                } else {
                    ImageClass.setImage(images.v9.V9EmilyMorningRoomDay3_8);
                    mc.talk(`Because we talked about it and I told her to stop seeing him.`);

                }

            }



        } else {
            ImageClass.setImage(images.v9.V9EmilyMorningRoomDay3_3);
            mc.talk(`Yup! She is perfect!`);
            ImageClass.setImage(images.v9.V9EmilyMorningRoomDay3_6);
            emily.talk(`Haha. I'm starting to believe you!`);
        }

    } else {
        ImageClass.setImage(images.v9.V9EmilyMorningRoomDay3_6);
        emily.talk(`But why wouldn't she let Alex date you? It's not like she is your girlfriend or something.`);
        ImageClass.setImage(images.v9.V9EmilyMorningRoomDay3_6);
        mc.talk(`Vanessa told me she is secretly in love with me and wants me all to herself or some shit.`);
        ImageClass.setImage(images.v9.V9EmilyMorningRoomDay3_10);
        emily.talk(`Look at you! A real ladies' man!`);
        emily.talk(`Do you think it's true?`);
        ImageClass.setImage(images.v9.V9EmilyMorningRoomDay3_6);
        mc.talk(`The more time passes I tend to believe it's true.`);

    }

    // if (Question.globalAnswers.v9VanessaMCChrisBarChoseGirlForChrisAgreement === "emily") {
    //     mc.talk(`By the way.`);

    // } else {

    // }

    ImageClass.setImage(images.v9.V9EmilyMorningRoomDay3_6);
    mc.talk(`Oh, I just remembered!`);
    mc.talk(`Are you still looking for a job?`);
    ImageClass.setImage(images.v9.V9EmilyMorningRoomDay3_3);
    emily.talk(`I am. Why? Have you got something for me?`);


    // I put it here and no in the dialogues above so it will be easy and clear to see the dialogues about Emily's new job
    // NTR off = no contact with Chris
    if (isAnnGF()) {
        // can happen only for NTR ON
        if (Question.globalAnswers.V8AnnDateMCOkWithChris !== undefined) {
            ImageClass.setImage(images.v9.V9EmilyMorningRoomDay3_6);
            mc.talk(`Well... The guy we were just talking about is looking for a bartender for his bar.`);
            ImageClass.setImage(images.v9.V9EmilyMorningRoomDay3_11);
            emily.talk(`Do you really want me to work for this guy?`);
            ImageClass.setImage(images.v9.V9EmilyMorningRoomDay3_8);
            mc.talk(`Why not? You said you are looking for a job.`);
            ImageClass.setImage(images.v9.V9EmilyMorningRoomDay3_5);
            emily.talk(`I am...`);
            ImageClass.setImage(images.v9.V9EmilyMorningRoomDay3_6);
            mc.talk(`So give it a try.`);
            if (Question.globalAnswers.v9VanessaMCChrisBarChoseGirlForChrisAgreement === "emily") {
                if (!Question.globalAnswers.V8AnnDateMCOkWithChris && Question.globalAnswers.v9AnnDormNightChrisMasturbated === false) {
                    mc.think(`Even though he saw Ann behind my back, I already told him I'll hook him up with Emily...`);
                }
                mc.talk(`Once you talk to him you'll see he is a great guy.`);

            }
            // NTR OFF or Vanessa route
        } else {
            ImageClass.setImage(images.v9.V9EmilyMorningRoomDay3_6);
            mc.talk(`There is this guy I know called Chris.`);
            mc.talk(`He runs a bar and needs someone to tend it for him.`);
            mc.talk(`He said he is looking for female bartender and I figured you might be a perfect fit for the job.`);
        }

        // ANN HATE
    } else {
        ImageClass.setImage(images.v9.V9EmilyMorningRoomDay3_6);
        mc.talk(`I do.`);
        mc.talk(`And funny coincidence... It's Ann's boyfriend that is the one looking for someone.`);
        mc.talk(`He owns a bar and is looking for female bartender to tend the bar for him.`);
    }
    mc.talk(`What do you say?`);
    ImageClass.setImage(images.v9.V9EmilyMorningRoomDay3_5);
    emily.talk(`Hmm...`);
    ImageClass.setImage(images.v9.V9EmilyMorningRoomDay3_10);
    emily.talk(`I've never worked as a bartender but I'm willing to give it a shot if he doesn't mind I don't have any experience!`);
    ImageClass.setImage(images.v9.V9EmilyMorningRoomDay3_6);
    mc.talk(`Great! I'll let him know.`);
    if (Question.globalAnswers.V8AnnDateMCOkWithChris === false) {
        ImageClass.setImage(images.v9.V9EmilyMorningRoomDay3_6);
        mc.talk(`But please, don't make any drama and talk to him about me and Ann.`);
        ImageClass.setImage(images.v9.V9EmilyMorningRoomDay3_9);
        emily.talk(`I promise!`);
    }
    doWaitImageByTime(v9.V9EmilyMorningRoomDay3_12);
    emily.talk(`Thank you! You are the best!`);
    mc.think(`A hug? She knows I'm naked...`);
    ImageClass.setImage(images.v9.V9EmilyMorningRoomDay3_13);
    emily.talk(`I'm waiting...`);
    mc.talk(`Mmm... I have this situation...`);
    ImageClass.setImage(images.v9.V9EmilyMorningRoomDay3_14);
    emily.talk(`Still? After yesterday?`);
    mc.think(`So she did feel me cumming on her leg!`);
    ImageClass.setImage(images.v9.V9EmilyMorningRoomDay3_13);
    if (Question.globalAnswers.v9AlexDateAfterJoinedHerWater) {
        emily.talk(`I'd figured that you'd... relieved some pressure after your spicy date yesterday...`);
    } else {
        emily.talk(`I'd figured that you'd... relieved some pressure after you left the living room yesterday...`);
    }
    mc.think(`Oh...`);
    mc.think(`Well. Fuck it.`);
    doWaitImageByTime(v9.V9EmilyMorningRoomDay3_15);
    emily.talk(`Thank you.`);
    doWaitImageByTime(v9.V9EmilyMorningRoomDay3_16);
    mc.think(`Yeah she definitely feels it.`);


    return jump(V9EmilyNightDayThreeMorning_2, "V9EmilyNightDayThreeMorning_2");
};

export const V9EmilyNightDayThreeMorning_2 = async (): Promise<any> => {
    doWaitImageByTime(v9.V9EmilyMorningRoomDay3_9);
    emily.talk(`Before you go, you should help me choose what I should wear for the interview!`);
    ImageClass.setImage(v9.V9EmilyMorningRoomDay3_8);
    mc.talk(`Woah there. Don't get ahead of yourself, I need to talk to him first.`);
    ImageClass.setImage(v9.V9EmilyMorningRoomDay3_5);
    emily.talk(`I know... I just like to be prepared.`);
    ImageClass.setImage(v9.V9EmilyMorningRoomDay3_6);
    mc.talk(`Can I get dressed first?`);
    ImageClass.setImage(v9.V9EmilyMorningRoomDay3_7);
    emily.talk(`No.`);
    ImageClass.setImage(v9.V9EmilyMorningRoomDay3_6);
    mc.talk(`Brush my teeth?`);
    ImageClass.setImage(v9.V9EmilyMorningRoomDay3_7);
    emily.talk(`No.`);
    ImageClass.setImage(v9.V9EmilyMorningRoomDay3_6);
    mc.talk(`...`);
    ImageClass.setImage(v9.V9EmilyMorningRoomDay3_9);
    emily.talk(`Wait here.`);
    doWaitImageByTime(v9.V9EmilyMorningRoomDay3_28);
    mc.talk(`Fuck me. I guess I'll wait then.`);
    doWaitImageByTime(v9.V9EmilyMorningRoomDay3_17);
    emily.talk(`Okay, so you are going to help me pick between two outfits.`);
    emily.talk(`This is the first one.`);
    doWaitImageByTime(v9.V9EmilyMorningRoomDay3_18);
    emily.talk(`It's a bit more conservative than what I usually wear, but I want to make a good impression.`);
    doWaitImageByTime(v9.V9EmilyMorningRoomDay3_18.partials.V9EmilyMorningRoomDay3_29_p);
    emily.talk(`Even though it's a bar... So I might want something else.`);
    doWaitImageByTime(v9.V9EmilyMorningRoomDay3_18);
    emily.talk(`Alright keep this image in your head. I'm going to be right back!`);
    doWaitImageByTime(v9.V9EmilyMorningRoomDay3_28, { wait: true });
    doWaitImageByTime(v9.V9EmilyMorningRoomDay3_19);
    emily.talk(`This is the second one!`);
    doWaitImageByTime(v9.V9EmilyMorningRoomDay3_20);
    emily.talk(`Yeah, I know it's a bit revealing.`);
    doWaitImageByTime(v9.V9EmilyMorningRoomDay3_23);
    emily.talk(`But it's a bar. So this is how you get tips, right?`);
    doWaitImageByTime(v9.V9EmilyMorningRoomDay3_25);
    mc.think(`Fuck me.`);
    doWaitImageByTime(v9.V9EmilyMorningRoomDay3_26);
    mc.think(`Little ${mc.name} just got excited.`);
    doWaitImageByTime(v9.V9EmilyMorningRoomDay3_24);
    emily.talk(`Haha. ${mc.name}!`);
    mc.talk(`What?! I can't control it.`);
    emily.talk(`Haha.`);
    emily.talk(`You better answer the question quick so don't continue to feel frustrated!`);
    await emily.setQuestion(new Question({ text: `Which outfit should I go to the interview with?`, options: { think: false }, key: `v9EmilyMorningDay3PickedRevealingOutfit` })
        .option({ title: `The first one (more conservative)`, key: false })
        .option({ title: `This one`, key: true }));


    if (Question.globalAnswers.v9EmilyMorningDay3PickedRevealingOutfit) {
        mc.talk(`This one.`);
    } else {
        mc.talk(`The first one.`);
    }

    emily.talk(`Alright! Thank you so much for your help!`);

    return jump(V9EmilyMorningRoomDay3After, "V9EmilyMorningRoomDay3After");
};








